var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPharmaExchangeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 30,
    viewBox: "0 0 380 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "AIPharmaExchange.com",
    transform: "translate(2 24)",
    fill: "#025ea9",
    fontSize: 26,
    fontFamily: "ErasITC-Bold, Eras ITC",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#e11d38"
  }, "PHARMA"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "EXCHANGE.COM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPharmaExchangeLogo);
export default __webpack_public_path__ + "static/media/AIPharmaExchange._logo.c96cdf8631c9e0dfc819120fc9bc99ac.svg";
export { ForwardRef as ReactComponent };